/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPINCOMEOPTION } from './IAPINCOMEOPTION';
import {
    IAPINCOMEOPTIONFromJSON,
    IAPINCOMEOPTIONFromJSONTyped,
    IAPINCOMEOPTIONToJSON,
} from './IAPINCOMEOPTION';
import type { IAPSWITCHFREQUENCY } from './IAPSWITCHFREQUENCY';
import {
    IAPSWITCHFREQUENCYFromJSON,
    IAPSWITCHFREQUENCYFromJSONTyped,
    IAPSWITCHFREQUENCYToJSON,
} from './IAPSWITCHFREQUENCY';
import type { IAPSWITCHOUTTYPE } from './IAPSWITCHOUTTYPE';
import {
    IAPSWITCHOUTTYPEFromJSON,
    IAPSWITCHOUTTYPEFromJSONTyped,
    IAPSWITCHOUTTYPEToJSON,
} from './IAPSWITCHOUTTYPE';
import type { IAPSWITCHTYPE } from './IAPSWITCHTYPE';
import {
    IAPSWITCHTYPEFromJSON,
    IAPSWITCHTYPEFromJSONTyped,
    IAPSWITCHTYPEToJSON,
} from './IAPSWITCHTYPE';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';
import type { InvestmentDetailsPhaseInFromFundViewModel } from './InvestmentDetailsPhaseInFromFundViewModel';
import {
    InvestmentDetailsPhaseInFromFundViewModelFromJSON,
    InvestmentDetailsPhaseInFromFundViewModelFromJSONTyped,
    InvestmentDetailsPhaseInFromFundViewModelToJSON,
} from './InvestmentDetailsPhaseInFromFundViewModel';
import type { InvestmentDetailsPhaseInToFundViewModel } from './InvestmentDetailsPhaseInToFundViewModel';
import {
    InvestmentDetailsPhaseInToFundViewModelFromJSON,
    InvestmentDetailsPhaseInToFundViewModelFromJSONTyped,
    InvestmentDetailsPhaseInToFundViewModelToJSON,
} from './InvestmentDetailsPhaseInToFundViewModel';

/**
 * 
 * @export
 * @interface InvestmentDetailsPhaseInViewModel
 */
export interface InvestmentDetailsPhaseInViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    immediateSwitch?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    nextDueDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    numberOfOccurences?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    switchValue?: number;
    /**
     * 
     * @type {IAPSWITCHFREQUENCY}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    frequencyId?: IAPSWITCHFREQUENCY;
    /**
     * 
     * @type {IAPSWITCHOUTTYPE}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    switchOutTypeId?: IAPSWITCHOUTTYPE;
    /**
     * 
     * @type {IAPSWITCHTYPE}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    switchTypeId?: IAPSWITCHTYPE;
    /**
     * 
     * @type {InvestmentDetailsPhaseInFromFundViewModel}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    holdingFund?: InvestmentDetailsPhaseInFromFundViewModel;
    /**
     * 
     * @type {Array<InvestmentDetailsPhaseInToFundViewModel>}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    toFunds?: Array<InvestmentDetailsPhaseInToFundViewModel>;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    hasPhaseIn: IAPYESORNO;
    /**
     * 
     * @type {IAPINCOMEOPTION}
     * @memberof InvestmentDetailsPhaseInViewModel
     */
    phaseInToOption?: IAPINCOMEOPTION;
}

/**
 * Check if a given object implements the InvestmentDetailsPhaseInViewModel interface.
 */
export function instanceOfInvestmentDetailsPhaseInViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hasPhaseIn" in value;

    return isInstance;
}

export function InvestmentDetailsPhaseInViewModelFromJSON(json: any): InvestmentDetailsPhaseInViewModel {
    return InvestmentDetailsPhaseInViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsPhaseInViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsPhaseInViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'immediateSwitch': !exists(json, 'ImmediateSwitch') ? undefined : json['ImmediateSwitch'],
        'nextDueDate': !exists(json, 'NextDueDate') ? undefined : (new Date(json['NextDueDate'])),
        'numberOfOccurences': !exists(json, 'NumberOfOccurences') ? undefined : json['NumberOfOccurences'],
        'switchValue': !exists(json, 'SwitchValue') ? undefined : json['SwitchValue'],
        'frequencyId': !exists(json, 'FrequencyId') ? undefined : IAPSWITCHFREQUENCYFromJSON(json['FrequencyId']),
        'switchOutTypeId': !exists(json, 'SwitchOutTypeId') ? undefined : IAPSWITCHOUTTYPEFromJSON(json['SwitchOutTypeId']),
        'switchTypeId': !exists(json, 'SwitchTypeId') ? undefined : IAPSWITCHTYPEFromJSON(json['SwitchTypeId']),
        'holdingFund': !exists(json, 'HoldingFund') ? undefined : InvestmentDetailsPhaseInFromFundViewModelFromJSON(json['HoldingFund']),
        'toFunds': !exists(json, 'ToFunds') ? undefined : ((json['ToFunds'] as Array<any>).map(InvestmentDetailsPhaseInToFundViewModelFromJSON)),
        'hasPhaseIn': IAPYESORNOFromJSON(json['HasPhaseIn']),
        'phaseInToOption': !exists(json, 'PhaseInToOption') ? undefined : IAPINCOMEOPTIONFromJSON(json['PhaseInToOption']),
    };
}

export function InvestmentDetailsPhaseInViewModelToJSON(value?: InvestmentDetailsPhaseInViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'ImmediateSwitch': value.immediateSwitch,
        'NextDueDate': value.nextDueDate === undefined ? undefined : (value.nextDueDate.toISOString()),
        'NumberOfOccurences': value.numberOfOccurences,
        'SwitchValue': value.switchValue,
        'FrequencyId': IAPSWITCHFREQUENCYToJSON(value.frequencyId),
        'SwitchOutTypeId': IAPSWITCHOUTTYPEToJSON(value.switchOutTypeId),
        'SwitchTypeId': IAPSWITCHTYPEToJSON(value.switchTypeId),
        'HoldingFund': InvestmentDetailsPhaseInFromFundViewModelToJSON(value.holdingFund),
        'ToFunds': value.toFunds === undefined ? undefined : ((value.toFunds as Array<any>).map(InvestmentDetailsPhaseInToFundViewModelToJSON)),
        'HasPhaseIn': IAPYESORNOToJSON(value.hasPhaseIn),
        'PhaseInToOption': IAPINCOMEOPTIONToJSON(value.phaseInToOption),
    };
}

